module.exports = __webpack_public_path__ + "img/logo3.8150dad3.svg";